var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-navigation-drawer",
    {
      style: {
        "margin-top": _vm.classification ? "5em" : "3.5em",
        "z-index": 11,
      },
      attrs: {
        value: _vm.value,
        clipped: _vm.$vuetify.breakpoint.lgAndUp,
        app: "",
        "disable-resize-watcher": "",
        "disable-route-watcher": "",
        fixed: "",
        temporary: "",
        width: "600px",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
        blur: function ($event) {
          _vm.value = false
        },
      },
    },
    [
      _c(
        "v-expansion-panels",
        {
          attrs: { accordion: "" },
          model: {
            value: _vm.active_path,
            callback: function ($$v) {
              _vm.active_path = $$v
            },
            expression: "active_path",
          },
        },
        [
          _c("DropdownContent", {
            attrs: {
              "header-text": "Results",
              files: _vm.visible_evaluation_files,
              "all-selected": _vm.all_evaluations_selected,
              "any-selected": _vm.any_evaluation_selected,
              "enable-compare-view": true,
              "compare-view-active": _vm.compareViewActive,
            },
            on: {
              "remove-selected": _vm.removeSelectedEvaluations,
              "toggle-all": _vm.toggle_all_evaluations,
              "toggle-compare-view": _vm.compareView,
              "changed-files": function ($event) {
                return _vm.$emit("changed-files")
              },
            },
          }),
          _c("DropdownContent", {
            attrs: {
              "header-text": "Profiles",
              files: _vm.visible_profile_files,
              "all-selected": _vm.all_profiles_selected,
              "any-selected": _vm.any_profile_selected,
            },
            on: {
              "remove-selected": _vm.removeSelectedProfiles,
              "toggle-all": _vm.toggle_all_profiles,
              "changed-files": function ($event) {
                return _vm.$emit("changed-files")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }